import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "preview", "iconInput"]

  connect() {
    console.log("IconSelector controller connected")
    // Initial search if name is pre-filled
    if (this.nameInputTarget.value) {
      this.search()
    }
  }

  search() {
    const name = this.nameInputTarget.value
    console.log("Searching for icon:", name)
    if (!name) {
      this.previewTarget.innerHTML = `
        <div class="text-sm text-zinc-500 dark:text-zinc-400">
          Type an amenity name to see suggested icons
        </div>
      `
      return
    }

    // Make a request to preview endpoint
    fetch(`/admin/icons/preview?name=${encodeURIComponent(name)}`, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
    .then(response => {
      console.log("Got response:", response.status)
      if (!response.ok) {
        console.error("Error fetching icons:", response.statusText)
        return
      }
      return response.text()
    })
    .then(html => {
      if (html) {
        console.log("Updating preview with HTML")
        this.previewTarget.innerHTML = html
      }
    })
    .catch(error => {
      console.error("Error:", error)
      this.previewTarget.innerHTML = `
        <div class="text-sm text-red-500">
          Error loading icons. Please try again.
        </div>
      `
    })
  }

  select(event) {
    const iconName = event.currentTarget.dataset.iconName
    console.log("Selected icon:", iconName)
    this.iconInputTarget.value = iconName

    // Update visual state of buttons
    const buttons = this.element.querySelectorAll('button')
    buttons.forEach(button => {
      button.classList.remove('ring-2', 'ring-primary-500')
      if (button.dataset.iconName === iconName) {
        button.classList.add('ring-2', 'ring-primary-500')
      }
    })
  }
}
